import React from "react";
import { TextLg, TextMd, TextSm } from "../../../components/text";
import chevron from "../../../assets/icons/chevron.svg";
import { useAppContext } from "../../../context/appContext";
import { SeeMore } from "../components/seeMore";

export const DataAnalyticsSection = ({
  className = "",
  style = {},
}) => {
  const { routing } = useAppContext();
  const { navigate } = routing;

  return (
    <button
      className={`flex w-full flex-col items-center gap-8 text-left ${className}`}
      style={style}
      onClick={()=>{
        navigate('/data-analytics');
      }}
    >
      <div className="w-full flex flex-col">
        <TextSm className="uppercase whitespace-nowrap tracking-[0.1em] text-blue-500 font-semibold">
          Data Analytics
        </TextSm>

        <TextMd className="font-semibold text-slate-900 mb-4">
          Transforming data into clear business direction.
        </TextMd>

        <TextSm className="text-slate-500 leading-7 mb-8">
          Analytics solutions designed to simplify complex datasets,
          automate reporting workflows, and provide actionable insights
          that support better business decisions.
        </TextSm>

        <div className="flex flex-wrap gap-x-8 gap-y-3">
          <div className="flex items-center gap-3 text-slate-700">
            <div className="h-1.5 w-1.5 rounded-full bg-blue-500" />
            <TextSm>Interactive Dashboards</TextSm>
          </div>

          <div className="flex items-center gap-3 text-slate-700">
            <div className="h-1.5 w-1.5 rounded-full bg-blue-500" />
            <TextSm>Reporting Automation</TextSm>
          </div>

          <div className="flex items-center gap-3 text-slate-700">
            <div className="h-1.5 w-1.5 rounded-full bg-blue-500" />
            <TextSm>Business Intelligence</TextSm>
          </div>
        </div>
      </div>
      
      <SeeMore />
      
    </button>
  );
};